/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
import CustomDatePicker from '../../../../components/DatePicker'
import dayjs from 'dayjs'
import Dropdown from '../../../../components/Dropdown';

export default function FilterActivityHistory({dateError,setdateError,isFilterOpen,setIsFilterOpen,handleApplyFilter,isFilterOrganization,initialState,filterValues,setFilterValues,handleOpenFilter}) {

    const optionAction= ['Created','Update','Deleted','Enable','Disable','View','Export','OTP Sent',
        'Removed','Invalid Attempt','Added','Acknowledged','Upload','Rejected','Alert Created',
        'Call','Email Sent',
    ];

    function handleOnChangeInput(id,option){
        const fieldToUpdate = {
            user_name:"user_name",
            field:"field",
            target:'target',
            user_type:"user_type",
            action:"action",

        }[id];
        if(fieldToUpdate){
            setFilterValues((prev)=>({
                ...prev,
                [fieldToUpdate]:option
            }))
        }
    }

    return (
        <div className='xl:relative ml-2.5'>
            <button id='filter' type='button' className='flex items-center border border-[#972E4C] rounded-[15px] px-4 py-2 min-w-max atr:mb-0 mb-3' onClick={handleOpenFilter}>
                <img src="/images/filter_icon.svg" alt="icon" />
                <span className='text-lg font-semibold text-[#972E4C] ml-2.5'>Filter</span>
            </button>
            {
                isFilterOpen && 
               
                    <div  className=' absolute top-[112px] xl:top-14 filter_top right-0 xl:left-[-344px] left-auto bg-white rounded-[15px] border border-[#D296B2] px-2.5 pt-4 py-[26px] shadow-s2 w-[454px] z-[99]'>
                        <div className='flex justify-between items-center mb-4'>
                            <p className='text-sm font-semibold text-[#52555D]'>Filter by:</p>
                            {/* {dateError &&<p className="text-xs text-red-500 mt-2 mr-8">Please select the valid date range.</p>} */}
                            <button type='button' onClick={()=>{setIsFilterOpen(!isFilterOpen),setdateError(false)}}>
                                <img src="/images/cross_mark_gray.svg" alt="icon" />
                            </button>
                        </div>
                        <div className='flex flex-wrap -mx-2'>
                            <div className='w-1/2 px-2 mb-4'>
                                <div className='w-full flex flex-col'>
                                    <label htmlFor="user_name" className='text-xs font-semibold text-[#000000] mb-1.5'>Username</label>
                                    <input
                                        type="text"
                                        placeholder="Enter username"
                                        id="user_name"
                                        autoComplete='off'
                                        value={filterValues?.user_name}                                     
                                        onChange={(e) => {handleOnChangeInput(e.target.id, e.target.value)}}
                                        className="px-3.5 py-2.5 border border-[#C5C9DA] rounded-lg placeholder:text-sm placeholder:font-normal placeholder:text-[#52555D] text-sm font-normal text-[#000000] outline-0"/>
                                        
                                </div>
                            </div>
                            <div className='w-1/2 px-2 mb-4'>
                                <div className='w-full flex flex-col'>
                                    <label htmlFor="field" className='text-xs font-semibold text-[#000000] mb-1.5'>Field</label>
                                    <input
                                        type="text"
                                        placeholder="Enter field"
                                        id="field"
                                        autoComplete='off'
                                        value={filterValues?.field}                                     
                                        onChange={(e) => {handleOnChangeInput(e.target.id, e.target.value)}}
                                        className="px-3.5 py-2.5 border border-[#C5C9DA] rounded-lg placeholder:text-sm placeholder:font-normal placeholder:text-[#52555D] text-sm font-normal text-[#000000] outline-0"/>
                                        
                                </div>
                            </div>
                            <div className='w-1/2 px-2 mb-4'>
                                <div className='w-full flex flex-col'>
                                    <label htmlFor="target" className='text-xs font-semibold text-[#000000] mb-1.5'>Username (Target)</label>
                                    <input
                                        type="text"
                                        placeholder="Enter username"
                                        id="target"
                                        autoComplete='off'
                                        value={filterValues?.target}                                     
                                        onChange={(e) => {handleOnChangeInput(e.target.id, e.target.value)}}
                                        className="px-3.5 py-2.5 border border-[#C5C9DA] rounded-lg placeholder:text-sm placeholder:font-normal placeholder:text-[#52555D] text-sm font-normal text-[#000000] outline-0"/>
                                        
                                </div>
                            </div>
                            <div className='w-1/2 px-2 mb-4'>
                                <div className='w-full flex flex-col'>
                                    <label htmlFor="user_type" className='text-xs font-semibold text-[#000000] mb-1.5'>Type (Target)</label>
                                    <input
                                        type="text"
                                        placeholder="Enter type"
                                        id="user_type"
                                        autoComplete='off'
                                        value={filterValues?.user_type}                                     
                                        onChange={(e) => {handleOnChangeInput(e.target.id, e.target.value)}}
                                        className="px-3.5 py-2.5 border border-[#C5C9DA] rounded-lg placeholder:text-sm placeholder:font-normal placeholder:text-[#52555D] text-sm font-normal text-[#000000] outline-0"/>
                                        
                                </div>
                            </div>
                            <div className='w-1/2 px-2 mb-4'>
                                <div className="w-full">
                                    <Dropdown
                                        label={"Action Performed"} 
                                        placeholder={"Select action performed"}
                                        id={"action"}
                                        htmlFor={"dateFormat"}
                                        filterScroll={true}
                                        value={filterValues?.action}
                                        options={optionAction}
                                        handleOnChangeInput={handleOnChangeInput}
                                        actionDropdown={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="flex mt-[13px] justify-between">
                            <button  onClick={()=>{handleApplyFilter(false),setIsFilterOpen(false)}}
                                id="Cancel"
                                className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-lg font-semibold text-[#972E4C] mr-[38px]" 
                            >Clear All</button>
                            <button  
                                onClick={()=>{
                                    handleApplyFilter(true),setIsFilterOpen(false)}}
                                type='button'
                                id="apply-filter"
                                data-testid="apply-btn"
                                disabled={filterValues?.user_name?.trim() === "" && filterValues?.field?.trim() === "" && filterValues?.target?.trim() === "" && filterValues?.user_type?.trim() === "" && filterValues?.action === ""} 
                                className={`py-2.5 w-[106px] px-4 rounded-[16px]  
                                disabled:bg-[#777C88] bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] border disabled:border-[#777C88] border-[#972E4C]  
                                 text-lg font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                                Apply
                            </button>
                        </div>
                    </div>
                // </motion.div>
            }
        </div>  
    )
}
